import { apiSlice } from "../api/apiSlice";

export const agentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAgents: builder.query({
      query: ({ locale }: { locale: string }) => {
        return `/agents?populate=photo&locale=${locale}`;
      },
      transformResponse: (response: { data: any }) => response.data,
    }),
    createAgent: builder.mutation({
      query: ({ agentData, locale }) => ({
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        url: `/agents?locale=${locale}`,
        method: "POST",
        body: JSON.stringify({ data: agentData }),
      }),
    }),
    uploadImg: builder.mutation({
      query: (data) => ({
        url: `/upload`,
        method: "POST",
        body: data,
      }),
    }),
    updateAgent: builder.mutation({
      query: ({ agentData, documentId, locale }) => ({
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        url: `/agents/${documentId}?locale=${locale}`,
        method: "PUT",
        body: JSON.stringify({ data: agentData }),
      }),
    }),
  }),
});

export const {
  useGetAgentsQuery,
  useLazyGetAgentsQuery,
  useCreateAgentMutation,
  useUploadImgMutation,
  useUpdateAgentMutation,
} = agentsApiSlice;
